import React, {Component} from 'react';
import {Link} from 'react-router';
import _ from 'lodash';
import style from './style.scss';


const LIB_TITLE = '<RN UI LIB>';

export default class Intro extends Component {
  render() {
    return (
      <div className={style.intro}>
        <ul className={style.topbar}>
          <li> <a target="_blank" href="https://github.com/wix/react-native-ui-lib" rel="noreferrer noopener">GITHUB</a></li>
          <li><Link to="/docs/getting-started">DOCS</Link></li>
        </ul>

        <div className={style.introWelcome}>
          <div className={style.bigTitle}>{LIB_TITLE}</div>
          <div className={style.subtitle}>Powerfull cross-platform UI components library for React Native</div>
        </div>

        {/*<div className={style.body}>
          <div className={style.content}>
            some more contnet..
          </div>
        </div>*/}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/Intro/index.js